import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { ProfileService } from '../_core/services/profile.service';
import { UserService } from '../_core/services/user.service';

import { AuthService } from './auth.service';

const _NUMBER_OF_PERMISSIONS = 0;

@Injectable()
export class AuthGuard {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly profileService = inject(ProfileService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login']);

      return false;
    }
    const expectedPermissions = route.data.expectedPermissions as string[];
    const expectedProfiles = route.data.expectedProfiles as string[];

    if (expectedProfiles === undefined && expectedPermissions === undefined) {
      return true;
    }

    if (expectedPermissions !== undefined) {
      const userPermissions = this.userService.getUser().userPermissions;

      const count = expectedPermissions.filter((expected) => userPermissions.includes(expected)).length;

      return count > _NUMBER_OF_PERMISSIONS;
    }

    if (expectedProfiles !== undefined) {
      const profile = this.profileService.getProfile();

      return expectedProfiles.includes(profile.role);
    }
  }

  doLogin(): void {
    this.userService.deleteUser();
    this.profileService.deleteProfile();

    if (environment.envName === 'local') {
      this.router.navigate(['login']);
    } else {
      window.location.href = '/listeners/adfs/login/';
    }
  }
}
